// extracted by mini-css-extract-plugin
export default {"root":"InfoPanelHeader_root__efYMI","wrapper":"InfoPanelHeader_wrapper__eNyuh","title":"InfoPanelHeader_title__hr+oO"};